import React from 'react';
import { cn } from '../../lib/utils';

export const ScrollArea = ({ className, children, ...props }) => (
  <div className={cn("relative overflow-auto", className)} {...props}>
    {children}
  </div>
);
